export const PORTFOLIO_BUILDER_PERMISSIONS = {
  VIEW: "PERMISSIONS.PORTFOLIO_BUILDER.VIEW",
};
